import React, {useState, useEffect, useRef, useContext} from 'react';

import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputNumber } from 'primereact/inputnumber';
import { Dropdown } from 'primereact/dropdown';
import { Toast } from 'primereact/toast';
import { Card } from 'primereact/card';
import { TabMenu } from 'primereact/tabmenu';
import { AuthContext } from "../../../../Header/auth - context";
import { confirmDialog } from 'primereact/confirmdialog';
import { ConfirmDialog } from 'primereact/confirmdialog'; // <- mora biti renderovana
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import CustomDropdown from '../../../../custom/customDropdown';
import { Tooltip } from 'primereact/tooltip';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { FileUpload } from 'primereact/fileupload';
import {excelBlobToJson} from '../../../../custom/excelToJson'
import { Checkbox } from 'primereact/checkbox';

const COL_DISPLAY_OUTPUT = {
    Dobavljac:    'Dobavljač',
    Kolicina:     'Količina',
    JedinicnaCena:'Jedinična cena',
    DatumSipanja: 'Datum sipanja',
    Vozac:        'Vozač',
    Kartica:      'Kartica',
};

const PumpsOutput = () => {
  /* Odgovor procedure dolazi kao NIZ redova, pa je poruka u prvom redu.
     Citanje sa samog niza daje undefined — zbog toga je odbijen unos ranije
     prolazio kao uspeh, a zapisa nije bilo. */
  const porukaIz = (data) => (Array.isArray(data) ? data?.[0]?.message : data?.message);
  const { t } = useTranslation();

        const toast = useRef(null);
        const formRef = useRef(null);
        const auth = useContext(AuthContext);
        const company = useSelector(state => state.company)
        const user = useSelector(state => state.user)
        const [selectedRowIdItem , setSelectedRowIdItem] = useState(null);
        const isSelected = (row) => String(getIdItem(row)) === String(selectedRowIdItem);
        const [changeView, setChangeView] = useState(1);
        const activeClass = 'activeButton'
        const [pumpsOptions, setPumpsOptions] = useState([])
        const [zaposleniOptions, setZaposleniOptions] = useState([])
        const [vozilaOptions, setVozilaOptions] = useState([])
        const [valuteOptions, setValuteOptions] = useState([])
        const [stanje, setStanje] = useState(null)

        /* ---- Cena goriva state ---- */
        const [ceneGoriva, setCeneGoriva] = useState([])
        const [selectedCenaId, setSelectedCenaId] = useState(null)
        const [cenaSubmitted, setCenaSubmitted] = useState(false)
        const [loadingCena, setLoadingCena] = useState(false)
        const emptyCena = { id_pumpa: null, iznos: null, id_valuta: null, datum_od: null, datum_do: null, napomena: '' }
        const [formCena, setFormCena] = useState(emptyCena)
        const [datumOdCena, setDatumOdCena] = useState(null)
        const [datumDoCena, setDatumDoCena] = useState(null)
        const [sviCena, setSviCena] = useState(false)
        const [idPumpa, setIdPumpa] = useState(null)
        const [izabran, setIzabran] = useState(false)
        const [idItem, setIdItem] = useState(null)
        const [popuni, setPopuni] = useState(false)
        const [globalFilter, setGlobalFilter] = useState(null);
        const [first, setFirst] = useState(0);
        const [tableData, setTableData] = useState(null);
        const [allColumns, setAllColumns] = useState([]);
        const [selectedColumns, setSelectedColumns] = useState([]);
        const [originalColumnOrder, setOriginalColumnOrder] = useState([]);
        const [porukaTimeRange, setPorukeTimeRange] = useState(null)
        const [formSubmitted, setFormSubmitted] = useState(false);
        const getIdItem = (row) => row?.ID ?? row?.id ?? row?.Izaberi ?? null;
        ///DATA

                const [datumOd, setDatumOd] = useState(null);
                const [datumDo, setDatumDo] = useState(null);
                const [sviIzlazi, setIzlazi] = useState(false);

        const resetFilter = () => {
          setDatumOd(null)
          setDatumDo(null)
          setIzlazi(false)
        }

         const [formData2, setFormData2] = useState({
            attachedExcel: null
        });

        const [formData, setFormData] = useState({
                    datum: null,
                    firma: '',
                    id_zaposleni: null,
                    id_vozilo: null,
                    kilometraza: null,
                    kolicina: null,
                    kartica: false
                });


    const handleErrors = (response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw response;
    }
  };


   useEffect(()=>{
    if(!formSubmitted){
                   let requestOptions = {
                              method: "POST",
                              headers: {
                              "Content-Type": "application/json",
                              Authorization: "Bearer " + auth.token,
                              },
                              body: JSON.stringify({
                                  svi: sviIzlazi
                              }),
                          };
                          fetch(process.env.REACT_APP_BACKEND_URL + "/fuel/GetFuelAndTypes", requestOptions)
                              .then(handleErrors)
                              .then((data) => {
                                
                                const stringifiedJson = data[0][""];
                                const parsedData = JSON.parse(stringifiedJson);
                                setTableData(parsedData.TocenjaDB)
                                setPumpsOptions(parsedData.PumpsDB)
                                setZaposleniOptions(parsedData.DriversDB)
                                setVozilaOptions(parsedData.VehiclesDB)
                                setStanje(parsedData.Stanje)
                                setValuteOptions(parsedData.ValuteDB || [])

                                 if (parsedData.TocenjaDB && parsedData.TocenjaDB.length > 0) {
                                                const columns = Object.keys(parsedData.TocenjaDB[0])
                                                    .filter(key => !['ID'].includes(key))
                                                    .map(key => ({
                                                    label: COL_DISPLAY_OUTPUT[key] || key,
                                                    value: key
                                                    }));
                                        
                                                 
                                                setAllColumns(columns);
                                                const originalOrder = Object.keys(parsedData.TocenjaDB[0]);
                                                setOriginalColumnOrder(originalOrder);
                                                
                                                // Select first 5 columns by default (or adjust as needed)
                                                setSelectedColumns(columns.slice(0, 10).map(col => col.value));
                                                }
                              })
                              .catch((error) => {
                              error.json().then((errorMessage) => {
                                  toast.current.show({
                                  severity: "error",
                                  summary: "Error",
                                  detail: errorMessage.message,
                                  life: 3000,
                                  });
                                  console.log(errorMessage);
                              });
                              });
                              
    }
      },[formSubmitted, sviIzlazi])



const resetData = ()=> {
        setFormData2({
            attachedExcel: null
        });
        setFormData({
                    datum: null,
                    firma: '',
                    id_zaposleni: null,
                    id_vozilo: null,
                    kilometraza: null,
                    kolicina: null,
                    kartica: false
        });
        setIdPumpa(null)
}
const handleDeleteItem = () => {
       
            confirmDialog({
            message: "Želite obrisati toćenje?",
            acceptLabel: "Da",
            rejectLabel: "Ne",
            icon: "pi pi-info-circle",
            acceptClassName: "p-button-danger",
            accept: acceptDelete,
            reject: rejectDelete,
            });

    };

    const acceptDelete = async () => {
 
  if (idItem) {
    setFormSubmitted(true)
     let requestOptions = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + auth.token,
          },
          body: JSON.stringify({
            id: idItem
          }),
        };
        
        fetch(process.env.REACT_APP_BACKEND_URL + "/fuel/DeleteUnloadBulk", requestOptions)
          .then(handleErrors)
          .then((data) => {
            
             toast.current.show({
                severity: "success",
                summary: "Uspešno pasiviziranje točenja!",
                life: 3000,
                });
                resetData()
                resetFilter()
                setIdItem(null)
                setFormSubmitted(false)
                setSelectedRowIdItem(null)
          })
          .catch((error) => {
            error.json().then((errorMessage) => {
              toast.current.show({
                severity: "error",
                summary: "Error",
                detail: errorMessage.message,
                life: 3000,
              });
              console.log(errorMessage);
            });
          });
  } else {
        toast.current.show({
            severity: "warn",
            summary: "Niste izabrali točenje za brisanje!",
            life: 3000,
            });
  }
   

  };
  const rejectDelete = () => {
    console.log("Odbijeno brisanje podataka!");
  }; 
  
  function toUtcIso(d) {
    if (!d) return null;
    const x = d instanceof Date ? d : new Date(d);
    const utc = new Date(x.getTime() - x.getTimezoneOffset() * 60000);
    return utc.toISOString().slice(0, 19) + 'Z';
    }

   const handleFormSubmit = (e) => {
  
                       e.preventDefault(); // bitno da ne submituje bez validacije
                  setFormSubmitted(true)
              if (formRef.current && !formRef.current.checkValidity()) {
                  formRef.current.reportValidity(); // prikazuje native browser poruke
                  return;
              }
      handleUploadAndSave()
   }
          const handleUploadAndSave = () => {
         
              confirmDialog({
              message: "Jel ste sigurni da želite nastaviti sa unosom?",
              acceptLabel: "Da",
              rejectLabel: "Ne",
              icon: "pi pi-info-circle",
              acceptClassName: "p-button-danger",
              accept: acceptInsert,
              reject: rejectInsert,
              });
          
  
      };

      const acceptInsert = async () => {
  
        if(changeView == 1){
        if(!formData2.attachedExcel){
             toast.current.show({
                        severity: "warn",
                        summary: "Upozorenje!",
                        detail: "Niste izabrali dokument za import!",
                        life: 3000,
                    });
                  return
                }
              //DATA
              let dataBulk;
             if(formData2.attachedExcel){
                dataBulk = await excelBlobToJson(formData2.attachedExcel.objectURL);

                /* validacija: provjeri da li svaki datum točenja ima pokrivenu cenu goriva */
                try {
                    const cenaData = await apiCena({ step: 'INIT_CENA' });
                    const cene = Array.isArray(cenaData) ? cenaData : [];

                    const toDateOnly = (val) => {
                        if (!val) return null;
                        if (val instanceof Date) return new Date(val.getFullYear(), val.getMonth(), val.getDate());
                        const s = String(val);
                        const parts = s.split('.');
                        if (parts.length >= 3) {
                            const [d, m, y] = parts.map(p => parseInt(p, 10));
                            return new Date(y, m - 1, d);
                        }
                        const parsed = new Date(val);
                        return isNaN(parsed.getTime()) ? null : new Date(parsed.getFullYear(), parsed.getMonth(), parsed.getDate());
                    };

                    const uncovered = [];
                    dataBulk.forEach(row => {
                        const dt = toDateOnly(row.DatumSipanja);
                        if (!dt) return;
                        const covered = cene.some(c => {
                            const od = toDateOnly(c.datum_od);
                            const ddo = toDateOnly(c.datum_do);
                            return od && ddo && dt >= od && dt <= ddo;
                        });
                        if (!covered) {
                            const label = String(row.DatumSipanja || '').split(' ')[0];
                            if (label && !uncovered.includes(label)) uncovered.push(label);
                        }
                    });

                    if (uncovered.length > 0) {
                        toast.current.show({
                            severity: 'error',
                            summary: 'Import nije moguć!',
                            detail: `Nema unesene cene goriva za datum(e): ${uncovered.join(', ')}`,
                            life: 7000,
                        });
                        setFormSubmitted(false);
                        return;
                    }
                } catch {
                    toast.current.show({ severity: 'warn', summary: 'Upozorenje', detail: 'Nije moguće proveriti cene goriva. Nastavite oprezno.', life: 4000 });
                }

                /* auto-match id_vozilo po reg tablicama: ukloni crtice i razmake, case-insensitive */
                const normPlate = str => String(str || '').replace(/[-\s]/g, '').toUpperCase();
                const vehicleLookup = {};
                (vozilaOptions || []).forEach(v => {
                    const n = normPlate(v.label);
                    if (n) vehicleLookup[n] = v.value;
                });
                dataBulk = dataBulk.map(row => {
                    if (row.id_vozilo) return row;
                    const matchedId = Object.values(row).reduce((found, val) => {
                        if (found) return found;
                        const n = normPlate(val);
                        return vehicleLookup[n] ?? null;
                    }, null);
                    return matchedId ? { ...row, id_vozilo: matchedId } : row;
                });

                 let requestOptions = {
                              method: "POST",
                              headers: {
                              "Content-Type": "application/json",
                              Authorization: "Bearer " + auth.token,
                              },
                              body: JSON.stringify({
                                  formData: dataBulk,
                                  id_pumpa: idPumpa
                              }),
                          };
                          
                          await fetch(process.env.REACT_APP_BACKEND_URL + "/fuel/InsertUnloadBulk", requestOptions)
                              .then(handleErrors)
                              .then((data) => {
    
                                if(data)
                                  toast.current.show({
                                    severity: "success",
                                    summary: "Import završen",
                                    detail: `Ubačeno: ${data[0].inserted_rows}, Duplikati: ${data[0].duplicate_rows}, Neispravni: ${data[0].invalid_rows}`,
                                    life: 4000
                                    });

                                  resetData()
                                  resetFilter()
                                  setFormSubmitted(false)

                              })
                              .catch((error) => {
                              error.json().then((errorMessage) => {
                                  toast.current.show({
                                  severity: "error",
                                  summary: "Error",
                                  detail: errorMessage.message,
                                  life: 3000,
                                  });
                                  console.log(errorMessage);
                              });
                              });
             }
        } else {

           const hasAnyValue = Object.values(formData).some(value => {
                  if (value === null || value === '') return false;
  
                  // Check if it's a valid Date object
                  if (value instanceof Date && isNaN(value.getTime())) return false;
  
                  return true;
                  });
                  let datum = toUtcIso(formData.datum)
                  const payload = {
                        ...formData,
                        datum
                        };
                    if(izabran && idItem){
                 if(hasAnyValue){                        
                    
                          let requestOptions = {
                            method: "POST",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            },
                            body: JSON.stringify({
                                id: Number(idItem),
                                id_pumpa: idPumpa,
                                formData: payload
                            }),
                        };
                
                        await fetch(process.env.REACT_APP_BACKEND_URL + "/fuel/UpdateUnload", requestOptions)
                            .then(handleErrors)
                            .then((data) => {
                             
                               if(data){
                                    if(data[0].message && data[0].message != 'Nema izmena u podacima točenja.' && data[0].message != 'Nedostaje id za UPDATE.' 
                                        && data[0].message != 'Zapis nije pronađen ili nije aktivan.' && data[0].message != 'Izmena nije moguća: postoji drugi identičan aktivan unos točenja.'){
                                    toast.current.show({
                                    severity: "error",
                                    summary: "Error",
                                    detail: data[0].message,
                                    life: 3000,
                                    });
                                    return
                                }  

                                if(data[0].message){
                                toast.current.show({
                                severity: "warn",
                                summary: data[0].message,
                                life: 3000,
                                });
                                return
                               }

                                toast.current.show({
                                severity: "success",
                                summary: "Uspešna izmena podataka točenja!",
                                life: 3000,
                                });
                                
                                resetFilter()
                                setFormSubmitted(false)
                                setIdItem(null)
                                setSelectedRowIdItem(null)
                                setIzabran(false)
                                resetData()
                                } 
                                
                            })
                            .catch((error) => {
                            error.json().then((errorMessage) => {
                                toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: errorMessage.message,
                                life: 3000,
                                });
                                console.log(errorMessage);
                            });
                            });
                } else {
                        toast.current.show({
                        severity: "warn",
                        summary: "Upozorenje!",
                        detail: "Niste popunili podatke sipanja!",
                        life: 3000,
                    });
                }
           
           
                } else {
                  if(hasAnyValue){
                      
                            let requestOptions = {
                              method: "POST",
                              headers: {
                              "Content-Type": "application/json",
                              Authorization: "Bearer " + auth.token,
                              },
                              body: JSON.stringify({
                                  id_pumpa: idPumpa,
                                  formData: payload
                              }),
                          };
                          
                          await fetch(process.env.REACT_APP_BACKEND_URL + "/fuel/InsertUnload", requestOptions)
                              .then(handleErrors)
                              .then((data) => {

                                  if(porukaIz(data)) {
                                        if(porukaIz(data) != 'Već postoji identično aktivno sipanje za ovu pumpu i datum.' ){ 
                                        toast.current.show({
                                        severity: "error",
                                        summary: "Error",
                                        detail: porukaIz(data),
                                        life: 3000,
                                        });
                                        return
                                        } else {
                                            toast.current.show({
                                        severity: "warn",
                                        summary: "Upozorenje",
                                        detail: porukaIz(data),
                                        life: 3000,
                                        });
                                        return
                                        }
                                  } 
                                  
                                  resetData()
                                  setFormSubmitted(false)
  
                                 toast.current.show({
                                  severity: "success",
                                  summary: "Uspešan unos podataka točenja!",
                                  life: 3000,
                                  });

                              })
                              .catch((error) => {
                              error.json().then((errorMessage) => {
                                  toast.current.show({
                                  severity: "error",
                                  summary: "Error",
                                  detail: errorMessage.message,
                                  life: 3000,
                                  });
                                  console.log(errorMessage);
                              });
                              });
                  } else {
                          toast.current.show({
                          severity: "warn",
                          summary: "Upozorenje!",
                          detail: "Niste popunili podatke točenja za unos!",
                          life: 3000,
                      });
                  }
            }

        }
                 
  
    };
      const rejectInsert = () => {
      console.log("Odbijen unos podataka!");
    };

    /* ========================= CENA GORIVA ========================= */
    const apiCena = (payload) =>
        fetch(process.env.REACT_APP_BACKEND_URL + '/fuel/ManageCenaGoriva', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + auth.token },
            body: JSON.stringify(payload),
        }).then(handleErrors);

    const loadCeneGoriva = () => {
        setLoadingCena(true);
        apiCena({ step: 'INIT_CENA' })
            .then(data => { setCeneGoriva(Array.isArray(data) ? data : []); setLoadingCena(false); })
            .catch(() => { setLoadingCena(false); toast.current.show({ severity: 'error', summary: 'Greška pri učitavanju cena goriva!', life: 3000 }); });
    };

    useEffect(() => { if (changeView === 3) loadCeneGoriva(); }, [changeView]); // eslint-disable-line

    const handleCenaRowSelect = (row) => {
        const id = row?.id;
        setSelectedCenaId(prev => {
            const next = String(prev) === String(id) ? null : id;
            if (next !== null) {
                setFormCena({
                    id_pumpa: row.id_pumpa,
                    iznos: Number(row.iznos),
                    id_valuta: row.id_valuta,
                    datum_od: new Date(row.datum_od),
                    datum_do: new Date(row.datum_do),
                    napomena: row.napomena || '',
                });
            } else {
                setFormCena(emptyCena);
                setCenaSubmitted(false);
            }
            return next;
        });
    };

    const handleSaveCena = async () => {
        setCenaSubmitted(true);
        if (!formCena.iznos || !formCena.id_valuta || !formCena.datum_od || !formCena.datum_do) return;
        if (formCena.datum_do < formCena.datum_od) {
            toast.current.show({ severity: 'warn', summary: 'Datum DO mora biti posle datuma OD!', life: 3000 });
            return;
        }
        const payload = {
            step: 'SAVE_CENA',
            id: selectedCenaId || 0,
            iznos: formCena.iznos,
            id_valuta: formCena.id_valuta,
            datum_od: toUtcIso(formCena.datum_od),
            datum_do: toUtcIso(formCena.datum_do),
            napomena: formCena.napomena || null,
        };
        try {
            const data = await apiCena(payload);
            const row = Array.isArray(data) ? data[0] : data;
            if (row?.message && !row?.ID) {
                toast.current.show({ severity: 'warn', summary: row.message, life: 4000 });
                return;
            }
            toast.current.show({ severity: 'success', summary: selectedCenaId ? 'Cena goriva izmenjena!' : 'Cena goriva unesena!', life: 3000 });
            setFormCena(emptyCena); setSelectedCenaId(null); setCenaSubmitted(false);
            loadCeneGoriva();
        } catch { toast.current.show({ severity: 'error', summary: 'Greška pri čuvanju cene goriva!', life: 3000 }); }
    };

    const handleDeleteCena = () => {
        if (!selectedCenaId) return;
        confirmDialog({
            message: 'Obrisati izabranu cenu goriva?',
            acceptLabel: 'Da', rejectLabel: 'Ne', icon: 'pi pi-info-circle', acceptClassName: 'p-button-danger',
            accept: async () => {
                try {
                    const data = await apiCena({ step: 'DELETE_CENA', id: selectedCenaId });
                    const row = Array.isArray(data) ? data[0] : data;
                    toast.current.show({ severity: 'success', summary: row?.message || 'Obrisano!', life: 3000 });
                    setFormCena(emptyCena); setSelectedCenaId(null); setCenaSubmitted(false);
                    loadCeneGoriva();
                } catch { toast.current.show({ severity: 'error', summary: 'Greška pri brisanju!', life: 3000 }); }
            },
        });
    };

    const invalidCena = (val) => cenaSubmitted && (val === null || val === undefined || val === '');

    const exportExcelCena = async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Cena goriva');
        const headers = ['Iznos', 'Valuta', 'Datum OD', 'Datum DO', 'Napomena'];
        const headerRow = worksheet.addRow(headers);
        headerRow.font = { bold: true };
        headerRow.eachCell(cell => {
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFEFEFEF' } };
            cell.border = { top: { style: 'medium' }, left: { style: 'medium' }, bottom: { style: 'medium' }, right: { style: 'medium' } };
        });
        (ceneGoriva || []).forEach(r => {
            const row = worksheet.addRow([Number(r.iznos), r.valuta_naziv, r.datum_od_prikaz, r.datum_do_prikaz, r.napomena || '']);
            row.eachCell(cell => {
                cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            });
        });
        worksheet.columns.forEach(col => {
            let max = 10;
            col.eachCell(cell => { if (cell.value) max = Math.max(max, String(cell.value).length); });
            col.width = max + 2;
        });
        const dt = new Date().toLocaleString('sr-RS', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', timeZone: 'Europe/Belgrade' }).replace(/,/g, '');
        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }), `Cena goriva - ${company.companyName} - ${dt}.xlsx`);
    };

    const headerCena = (
        <div className="export-buttons fakture-stavke-header">
            <div className="fakture-stavke-radnje">
                <Button type="button" icon="pi pi-file-excel" severity="success" rounded onClick={exportExcelCena} data-pr-tooltip="XLS" />
                {selectedCenaId && <Button type="button" style={{marginLeft:'5px'}} icon="pi pi-trash" severity="danger" rounded onClick={handleDeleteCena} data-pr-tooltip="Obriši" />}
            </div>
                            <div style={{minHeight:'100%', display:'flex', justifyContent: 'center', alignItems:'center', minWidth: '5%'}}>
                    <Checkbox
                        id="sviCena"
                        name="sviCena"
                        checked={sviCena}
                        onChange={(e) => setSviCena(e.target.checked)}
                        tooltip="SVI UNOSI"
                        tooltipOptions={{ position: 'top' }}
                    />
                
                <Calendar
                    value={datumOdCena}
                    onChange={(e) => setDatumOdCena(e.value)}
                    placeholder="Datum OD"
                    dateFormat="dd.mm.yy"
                    mask="99.99.9999"
                    style={{marginRight:'1%', maxWidth:'20%'}}
                />
                <Calendar
                    value={datumDoCena}
                    onChange={(e) => setDatumDoCena(e.value)}
                    placeholder="Datum DO"
                    dateFormat="dd.mm.yy"
                    mask="99.99.9999"
                    style={{marginRight:'1%', maxWidth:'20%'}}
                />
                <input
                    style={{width:'30%'}}
                    type="search"
                    onInput={(e) => setGlobalFilter(e.target.value)}
                    placeholder={t('nova.phPretraga')}
                    className="p-inputtext p-component"
                />
            </div>
        </div>
    );
  
   const handleChange2 = (name, file) => {

        if (name in formData2) {
        setFormData2(prev => ({ ...prev, [name]: file }));
        } 
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        
        if (name in formData) {
        setFormData(prev => ({ ...prev, [name]: value }));
        }
    };

  const exportExcel = async () => {
      if (!selectedColumns || selectedColumns.length === 0) return;
  
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Točenja');
  
      const headers = selectedColumns;

      const headerRow = worksheet.addRow(headers);
      headerRow.font = { bold: true };
      headerRow.eachCell((cell) => {
          cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'FFEFEFEF' }
          };
          cell.border = {
              top: { style: 'medium' },
              left: { style: 'medium' },
              bottom: { style: 'medium' },
              right: { style: 'medium' }
          };
      });
  
      tableData.forEach((rowData) => {
          const row = worksheet.addRow(headers.map(h => rowData[h] ?? ""));
          row.eachCell((cell) => {
              cell.border = {
                  top: { style: 'thin' },
                  left: { style: 'thin' },
                  bottom: { style: 'thin' },
                  right: { style: 'thin' }
              };
          });
      });
  
      worksheet.columns.forEach((column, i) => {
          const lengths = [
              headers[i].length,
              ...tableData.map(row => (row[headers[i]] ?? "").toString().length)
          ];
          column.width = Math.max(...lengths) + 2;
      });
  
      const date = new Date();
      const options = {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          timeZone: 'Europe/Belgrade'
      };
      const serbianDateTime = date.toLocaleString('sr-RS', options)
          .replace(/\s/g, ' ')
          .replace(/,/g, '');
  
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      saveAs(blob, `Točenja - ${company.companyName} - ${serbianDateTime}.xlsx`);
  };
       const header = (
          <div className="export-buttons fakture-stavke-header">
              <div className="fakture-stavke-radnje">              
              <Button type="button" icon="pi pi-file-excel" severity="success" rounded onClick={exportExcel} data-pr-tooltip="XLS" />
              {selectedRowIdItem && <Button type="button" style={{marginLeft:'5px'}} icon="pi pi-trash" severity="danger" rounded onClick={handleDeleteItem} data-pr-tooltip="Print" />}             
              </div>
                                                         <div style={{minHeight:'100%', display:'flex', justifyContent: 'center', alignItems:'center',minWidth: '5%'}}>
                                            <Checkbox 
                                            id="sviIzlazi" 
                                            name="sviIzlazi" 
                                            checked={sviIzlazi} 
                                            onChange={(e)=>setIzlazi(e.target.checked)} 
                                            tooltip="SVI IZLAZI"
                                            tooltipOptions={{ position: 'top' }}
                                          />
                                          
                                          <Calendar
                                            value={datumOd}
                                            onChange={(e) => setDatumOd(e.value)}
                                            placeholder="Datum OD"
                                            dateFormat="dd.mm.yy"
                                            mask="99.99.9999"
                                            style={{marginRight:'1%', maxWidth:'20%'}}
                                          />
                                
                                          <Calendar
                                            value={datumDo}
                                            onChange={(e) => setDatumDo(e.value)}
                                            placeholder="Datum DO"
                                            dateFormat="dd.mm.yy"
                                            mask="99.99.9999"
                                            style={{marginRight:'1%', maxWidth:'20%'}}
                                          />
                                              <input
                                                style={{width:'30%'}}
                                                type="search"
                                                onInput={(e) => setGlobalFilter(e.target.value)}
                                                placeholder={t('nova.phPretraga')}
                                                className="p-inputtext p-component"
                                              /></div>
          </div>
      );

        const invalidControl = (data) => {
        if (!formSubmitted) return false;
    
        if (data && data != null && !Number(data)) {
        return data.length > 0 ? false : true;
        } else if (data != null && Number(data)) {
        return false;
        }
        return true;
    };

     const isButtonColumn = (field) => {
    return field.startsWith('Izaberi') || 
           field.includes('File') || 
           field.includes('fajl') || 
           field.includes('upload') ||
           field.endsWith('LK') || // Lična karta
           field.endsWith('VD') || // Vozačka dozvola
           field.endsWith('PASS') || // Pasoš
           field.endsWith('VIZA') || // Viza
           field.includes('Dokument'); // Generic document
  };

    const popuniStavke = (apiData) => {

   setIdPumpa(apiData[0].id_pumpa || null)

    setFormData({
        datum: apiData[0].datum ? new Date(apiData[0].datum.slice(0, 19)) : null,
        id_vozilo: apiData[0].id_vozilo || null,
        id_zaposleni: apiData[0].id_zaposleni || null,
        firma: apiData[0].firma || '',
        kilometraza: apiData[0].kilometraza || null,
        kolicina: apiData[0].kolicina || null,
        kartica: !!apiData[0].kartica
      });
};

      const popuniRedove = async (id) => {
  
        if(!id) {
             toast.current.show({
                        severity: "warn",
                        summary: "Upozorenje!",
                        detail: "Niste izabrali točenje da bi popunili podatke!",
                        life: 3000,
                    });
        } else {
              let requestOptions = {
                            method: "POST",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            },
                            body: JSON.stringify({
                                id
                            }),
                        };
                
                        await fetch(process.env.REACT_APP_BACKEND_URL + "/fuel/GetUnload", requestOptions)
                            .then(handleErrors)
                            .then((data) => {

                                if(porukaIz(data)){
                                    toast.current.show({
                                    severity: "error",
                                    summary: "Error",
                                    detail: porukaIz(data),
                                    life: 3000,
                                    });
                                    return
                                }  
                               
                                popuniStavke(data)
                                
                               toast.current.show({
                                severity: "success",
                                summary: "Uspešno popunjavanje podataka točenja!",
                                life: 3000,
                                });
                              
                            //ubaciti deo da se forma ID za dalji unos
                            })
                            .catch((error) => {
                            error.json().then((errorMessage) => {
                                toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: errorMessage.message,
                                life: 3000,
                                });
                                console.log(errorMessage);
                            });
                            });
        }
          
    }


    const chooseItem = (rowData) => {
        const id = getIdItem(rowData);

        setSelectedRowIdItem((prev) => {
        const next = String(prev) === String(id) ? null : String(id);

        if(next) {
        setIdItem(next)
        popuniRedove(id)
        setIzabran(true)
        setChangeView(2)
        }
        else {
        setIdItem(null)
        resetData()
        setIzabran(false)
        }

        return next;
    });
    }

     const previewBodyTemplate = (rowData, field) => {
      const filePathsString = rowData[field];
      if (!filePathsString) return '-';
     
      return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
              <Button
                label='Izaberi'
                icon="pi pi-eye"
                type="button"
                className="p-button-text p-button-sm"
                onClick={(e) => chooseItem(rowData)}
              />
            
        </div>
      );
    };

      const filteredData = tableData?.filter(item => {
      const datumString = item["DatumSipanja"];

      if (!datumString) return false; // zaštita

      // Pretvori "10.09.2025" → Date objekt
      const [day, month, year] = datumString.split(".");
      const datum = new Date(`${year}-${month}-${day}`);

      if (datumOd && datum < datumOd) return false;
      if (datumDo && datum > datumDo) return false;

      return true;
    });

    const currentYear = new Date().getFullYear();
    const filteredCeneGoriva = ceneGoriva.filter(item => {
        if (!item.datum_od) return true;
        const d = new Date(item.datum_od);
        if (!sviCena && d.getFullYear() !== currentYear) return false;
        if (datumOdCena && d < datumOdCena) return false;
        if (datumDoCena && d > datumDoCena) return false;
        return true;
    });

   return (
       <div style={{marginTop:"1%"}}> 
        <Toast ref={toast} />        

        <ConfirmDialog />

            <div className='col-12 md:col-6'>
                          <div className='blagajnaDashboard dnevniceDashboard'>
                             <Card style={{minWidth:'50%'}}>
                            <Button id={changeView == 1 && activeClass} label="Import" style={{fontSize: 'smaller', marginLeft: '0 !important', marginTop:'0 !impotant'}}  className="" onClick={()=> {setChangeView(1)} } />
                            <Button id={changeView == 2 && activeClass} label="Ručno" style={{fontSize: 'smaller'}}  className="mt-3 zaposleniShift" onClick={()=> {setChangeView(2)} } />
                            <Button id={changeView == 3 && activeClass} label={t('magacin.cenaGoriva')} style={{fontSize: 'smaller'}} className="mt-3 zaposleniShift" onClick={()=> {setChangeView(3)} } />
                            {changeView== 1 && <form autoComplete="off" ref={formRef} style={{marginTop:'1%', display:'flex', justifyContent:'center', minWidth:'50%'}}>
                            <div className="" style={{minWidth:'50%'}}>
                            <div className="col-12 md:col-6" style={{display: 'flex', flexDirection:'column'}}>
                                                                <label htmlFor="id_pumpa">{t('magacin.pumpa')}:</label>
                                                                            <CustomDropdown
                                                                                 id="id_pumpa" 
                                                                                 name="id_pumpa" 
                                                                                 value={idPumpa} 
                                                                                 options={pumpsOptions || []}
                                                                                 placeholder={t('magacin.phPumpu')}
                                                                                 required
                                                                                 invalid={invalidControl(idPumpa)}
                                                                                 optionLabel="label"
                                                                                 onChange={(e)=>setIdPumpa(e.target.value)} />
                                                              </div>
                               <div className="col-12 md:col-6" style={{display:'flex',flexDirection:'column', alignItems:'center'}}>
                                                                   <label htmlFor="attachedExcel">Dokument excela:</label>
                                                                   {!formData.attachedExcel ? 
                                                                       <FileUpload
                                                                           chooseLabel={"Izaberi"}
                                                                           name="attachedExcel"
                                                                           uploadLabel="Priloži"
                                                                           mode="basic"
                                                                           accept=".xls,.xlsx"
                                                                           required
                                                                           invalid={invalidControl(formData.attachedExcel)}
                                                                           maxFileSize={5000000}
                                                                           onSelect={(e) => handleChange2("attachedExcel", e.files[0])}
                                                                       /> : 
                                                                       <Button 
                                                                           label={formData.attachedExcel.name} 
                                                                           onClick={() => handleChange2("attachedExcel", null)} 
                                                                       />
                                                                   }
                                                               </div>
                             <div className="col-12 md:col-6" style={{display: 'flex', flexDirection:'column', justifyContent:'end'}}>
                                                                             <Button 
                                                                           label={"UNOS"} 
                                                                           onClick={handleFormSubmit} 
                                                                            type='submit'
                                                                            /* Boja ide kroz severity, ne kroz inline stil — inline boja ne zna
                                                                               za temu, pa je u tamnoj ostajala bootstrap-zelena dok su sva
                                                                               ostala dugmad „unesi/sačuvaj" prešla na paletu teme. */
                                                                            severity="success"
                                                                            style={{marginTop:'20px'}}
                                                                       />
                                                              </div>                                       
                            </div>
                            </form>}
                                                        {changeView== 2 && <><form autoComplete="off" ref={formRef} style={{marginTop:'1%'}}>
                            <div className="gridLicni">
                            <div className="col-12 md:col-6" style={{display: 'flex', flexDirection:'column'}}>
                                                                <label htmlFor="id_pumpa">{t('magacin.pumpa')}:</label>
                                                                            <CustomDropdown
                                                                                 id="id_pumpa" 
                                                                                 name="id_pumpa" 
                                                                                 value={idPumpa} 
                                                                                 options={pumpsOptions || []}
                                                                                 placeholder={t('magacin.phPumpu')}
                                                                                 required
                                                                                 invalid={invalidControl(idPumpa)}
                                                                                 optionLabel="label"
                                                                                 onChange={(e)=>setIdPumpa(e.target.value)} />
                                                              </div>
                                                              <div className="col-12 md:col-6" style={{display: 'flex', flexDirection: 'column'}}>
                                                                 <label htmlFor="datum">{t('nova.datum')}:</label>
                                                                        <Calendar 
                                                                            required 
                                                                            mask="99.99.9999 99:99" 
                                                                            invalid={invalidControl(formData.datum)} 
                                                                            id="datum" 
                                                                            name="datum" 
                                                                            value={formData.datum} 
                                                                            onChange={handleChange} 
                                                                            showIcon 
                                                                            dateFormat="dd.mm.yy" showTime hourFormat="24"
                                                                            />
                                                                </div>
                                                                <div className="col-12 md:col-6" style={{display: 'flex', flexDirection: 'column'}}>
                                                                <label htmlFor="firma">Firma:</label>
                                                                <InputText
                                                                id="firma" 
                                                                name="firma" 
                                                                required
                                                                invalid={invalidControl(formData.firma)} 
                                                                value={formData.firma} 
                                                                onChange={handleChange} 
                                                                />
                                                            </div>
                                                            <div className="col-12 md:col-6" style={{display: 'flex', flexDirection:'column'}}>
                                                            <label htmlFor="id_zaposleni">{t('ture.vozac')}:</label>
                                                                        <CustomDropdown
                                                                             id="id_zaposleni" 
                                                                             name="id_zaposleni" 
                                                                             value={formData.id_zaposleni} 
                                                                             options={zaposleniOptions || []}
                                                                             placeholder={t('ture.phVozaca')}
                                                                             required
                                                                            invalid={invalidControl(formData.id_zaposleni)}
                                                                             optionLabel="label"
                                                                             onChange={handleChange} />
                                                          </div>
                                                          <div className="col-12 md:col-6" style={{display: 'flex', flexDirection:'column'}}>
                                                            <label htmlFor="id_vozilo">{t('nova.vozilo')}:</label>
                                                                        <CustomDropdown
                                                                             id="id_vozilo" 
                                                                             name="id_vozilo" 
                                                                             value={formData.id_vozilo} 
                                                                             options={vozilaOptions || []}
                                                                             placeholder={t('nova.phVozilo')}
                                                                             optionLabel="label"
                                                                             onChange={handleChange} />
                                                          </div>
                                                          <div className="col-12 md:col-6" style={{display: 'flex', flexDirection  :'column'}}>
                                                                <label htmlFor="kilometraza">{t('ture.kilometraza')}:</label>
                                                                 <InputNumber
                                                                                                    id="kilometraza" 
                                                                                                    name="kilometraza" 
                                                                                                    value={formData.kilometraza} 
                                                                                                    onValueChange={handleChange} 
                                                                                                    minFractionDigits={2} maxFractionDigits={2} />
                                                            </div>
                                                          <div className="col-12 md:col-6" style={{display: 'flex', flexDirection  :'column'}}>
                                                                <label htmlFor="kolicina">{t('nova.kolicina')}:</label>
                                                                 <InputNumber
                                                                                                    id="kolicina" 
                                                                                                    name="kolicina" 
                                                                                                    value={formData.kolicina} 
                                                                                                    required
                                                                                                    invalid={invalidControl(formData.kolicina)}
                                                                                                    onValueChange={handleChange} 
                                                                                                    minFractionDigits={2} maxFractionDigits={2} />
                                                            </div>
                                                          <div className="col-12 md:col-6" style={{display: 'flex', flexDirection: 'column'}}>
                                                            <label>{t('magacin.kartica')}:</label>
                                                            <div style={{display: 'flex', alignItems: 'center', gap: '0.5rem', paddingTop: '0.4rem'}}>
                                                                <Checkbox
                                                                    inputId="kartica"
                                                                    checked={!!formData.kartica}
                                                                    onChange={e => setFormData(prev => ({...prev, kartica: e.checked}))}
                                                                />
                                                                <label htmlFor="kartica" style={{cursor:'pointer', marginBottom:0}}>Uračunati u obračun plate</label>
                                                            </div>
                                                          </div>

                                    
                            </div>
                            </form>                            <div className="formUnosZap buttonUnosZap">
                            <button type="submit" onClick={handleFormSubmit} style={{minWidth:"fit-content", marginTop:'2%'}} className="btn btn-success">
                                {izabran ? "SAČUVAJ" : "UNOS"}
                            </button>
                            </div></>
                            }
                            {changeView === 3 && (
                                <form autoComplete="off" style={{marginTop:'1%'}}>
                                    <div className="gridLicni">
                                        <div className="col-12 md:col-6" style={{display:'flex', flexDirection:'column'}}>
                                            <label>{t('nova.iznos')}:</label>
                                            <InputNumber
                                                value={formCena.iznos}
                                                onValueChange={e => setFormCena(p => ({...p, iznos: e.value}))}
                                                minFractionDigits={2} maxFractionDigits={2}
                                                invalid={invalidCena(formCena.iznos)} />
                                        </div>
                                        <div className="col-12 md:col-6" style={{display:'flex', flexDirection:'column'}}>
                                            <label>{t('nova.valuta')}:</label>
                                            <Dropdown
                                                value={formCena.id_valuta}
                                                options={valuteOptions}
                                                optionLabel="label" optionValue="value"
                                                placeholder="Izaberi valutu"
                                                invalid={invalidCena(formCena.id_valuta)}
                                                onChange={e => setFormCena(p => ({...p, id_valuta: e.value}))}
                                                style={{width:'100%'}} />
                                        </div>
                                        <div className="col-12 md:col-6" style={{display:'flex', flexDirection:'column'}}>
                                            <label>Datum OD:</label>
                                            <Calendar
                                                value={formCena.datum_od}
                                                onChange={e => setFormCena(p => ({...p, datum_od: e.value}))}
                                                dateFormat="dd.mm.yy" mask="99.99.9999" showIcon
                                                invalid={invalidCena(formCena.datum_od)} />
                                        </div>
                                        <div className="col-12 md:col-6" style={{display:'flex', flexDirection:'column'}}>
                                            <label>Datum DO:</label>
                                            <Calendar
                                                value={formCena.datum_do}
                                                onChange={e => setFormCena(p => ({...p, datum_do: e.value}))}
                                                dateFormat="dd.mm.yy" mask="99.99.9999" showIcon
                                                invalid={invalidCena(formCena.datum_do)} />
                                        </div>
                                        <div className="col-12 md:col-6" style={{display:'flex', flexDirection:'column'}}>
                                            <label>{t('nova.napomena')}:</label>
                                            <InputText
                                                value={formCena.napomena}
                                                onChange={e => setFormCena(p => ({...p, napomena: e.target.value}))} />
                                        </div>
                                    </div>
                                    <div className="formUnosZap buttonUnosZap">
                                        <button type="button" onClick={handleSaveCena} style={{minWidth:'fit-content', marginTop:'2%'}} className="btn btn-success">
                                            {selectedCenaId ? 'SAČUVAJ' : 'UNOS'}
                                        </button>
                                    </div>
                                </form>
                            )}

                             {stanje && stanje.length > 0 && (
                                    <>
                                        <h4 style={{marginTop:'1%'}}>{t('magacin.trenutnoStanjePumpe')}</h4>
                                        <div className='col-12 md:col-6'>
                                            {stanje.map((item, index) => (
                                                <div key={index} className="mb-2" style={{fontSize: '20px'}}>
                                                    {index + 1}. <b>{item.Naziv}</b>: {item.Stanje} [lit]
                                                </div>
                                            ))}
                                        </div>
                                    </>
                                    )}               
                          </Card>
                          <Card>
                            {changeView === 3 ? (
                                <>
                                    <Tooltip target=".export-buttons>button" position="bottom" />
                                    <DataTable
                                        value={filteredCeneGoriva}
                                        paginator rows={10}
                                        globalFilter={globalFilter}
                                        scrollable scrollHeight="50vh"
                                        header={headerCena}
                                        emptyMessage={loadingCena ? 'Učitavanje...' : 'Nema cena goriva'}
                                        resizableColumns columnResizeMode="expand"
                                        className="turePregledTable stavke-tabela"
                                        rowClassName={row => String(row.id) === String(selectedCenaId) ? {'selected-row': true} : {}}
                                    >
                                        <Column header={t('nova.izaberi')} style={{minWidth:'90px'}}
                                            body={row => (
                                                <Button label={t('nova.izaberi')} icon="pi pi-eye" type="button"
                                                    className="p-button-text p-button-sm"
                                                    onClick={() => handleCenaRowSelect(row)} />
                                            )} />
                                        <Column field="iznos" header={t('nova.iznos')} sortable style={{minWidth:'100px'}} body={r => Number(r.iznos).toFixed(2)} />
                                        <Column field="valuta_naziv" header={t('nova.valuta')} sortable style={{minWidth:'80px'}} />
                                        <Column field="datum_od_prikaz" header="Datum OD" sortable style={{minWidth:'110px'}} />
                                        <Column field="datum_do_prikaz" header="Datum DO" sortable style={{minWidth:'110px'}} />
                                        <Column field="napomena" header={t('nova.napomena')} style={{minWidth:'150px'}} body={r => r.napomena || '-'} />
                                    </DataTable>
                                </>
                            ) : (
                                <>
                                    <Tooltip target=".export-buttons>button" position="bottom" />
                                    <DataTable
                                        value={filteredData || []}
                                        paginator rows={10}
                                        first={first}
                                        globalFilter={globalFilter}
                                        onPage={(e) => setFirst(e.first)}
                                        scrollable
                                        header={header}
                                        scrollHeight="50vh"
                                        emptyMessage={t('common.noDataTable')}
                                        resizableColumns
                                        className="turePregledTable stavke-tabela"
                                        columnResizeMode="expand"
                                        rowClassName={(data) => (isSelected(data) ? "selected-row" : "")}
                                    >
                                        {selectedColumns.map((colKey) => {
                                            const colMeta = allColumns.find(col => col.value === colKey);
                                            return (
                                                <Column
                                                    key={colKey}
                                                    field={colKey}
                                                    header={colMeta?.label || colKey}
                                                    sortable
                                                    body={(rowData) => {
                                                        if (isButtonColumn(colKey)) return previewBodyTemplate(rowData, colKey);
                                                        const v = rowData[colKey];
                                                        if (typeof v === 'boolean') return v ? 'Da' : 'Ne';
                                                        return v || '-';
                                                    }}
                                                    style={{ minWidth: '150px'}}
                                                />
                                            );
                                        })}
                                    </DataTable>
                                </>
                            )}
                          </Card>
                          </div>
            </div>                                
                       
       </div>
)
}

export default PumpsOutput;